// Product / chapter names are saved in mixed styles in the master (some in ALL
// CAPS, some in normal case), so the lists looked inconsistent. This shows every
// name in Title Case for display only - the saved value is never changed.

// Abbreviations that must keep their own spelling. Add to this list if a new
// abbreviation shows up lowercased.
const ABBREVIATIONS = {
    CAD: 'CAD', CAM: 'CAM', CIM: 'CIM', ERP: 'ERP', COES: 'COEs', COE: 'COE',
    'TIT&S': 'TIT&S', MMF: 'MMF', PVC: 'PVC', PET: 'PET', PP: 'PP', UV: 'UV',
    IT: 'IT', CNC: 'CNC', PLC: 'PLC', AI: 'AI', IOT: 'IoT', ETP: 'ETP',
    ZLD: 'ZLD', HVAC: 'HVAC', LED: 'LED', UK: 'UK', USA: 'USA', SDC: 'SDC',
    PPE: 'PPE', 'R&D': 'R&D',
};

// Short joining words stay lowercase unless they start the name
const SMALL_WORDS = new Set(['and', 'or', 'of', 'for', 'the', 'in', 'to', 'with', 'by', 'a', 'an', 'on', 'at']);

export const formatChapterName = (name) => {
    if (name == null || name === '') return name;
    let isFirstWord = true;
    return String(name).replace(/[A-Za-z][A-Za-z&']*/g, (word) => {
        const upper = word.toUpperCase();
        const lower = word.toLowerCase();
        let out;
        if (ABBREVIATIONS[upper]) {
            out = ABBREVIATIONS[upper];
        } else if (!isFirstWord && SMALL_WORDS.has(lower)) {
            out = lower;
        } else {
            out = lower.charAt(0).toUpperCase() + lower.slice(1);
        }
        isFirstWord = false;
        return out;
    });
};

export default formatChapterName;
